import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '../../service/notification.service';
import { Subscription } from 'rxjs';
import { NotificationType } from '../../enum/notification-type.enum';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CalendarService } from '../../service/calendar.service';
import { CalendarModel } from '../../models/config/calendar.model';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import { saveAs } from 'file-saver';
import { NgForm } from '@angular/forms';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { GlobalService } from 'src/app/service/global.service';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';

@Component({
  selector: 'app-calendar-update',
  templateUrl: './calendar-update.component.html',
  styleUrls: ['./calendar-update.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class CalendarUpdateComponent implements OnInit, AfterViewInit {
  private subscriptions: Subscription[] = [];
  public refreshing: boolean;
  public ctype: string;
  selectedCalc: CalendarModel[] = [];
  selectedCalcIds: CalendarModel[] = [];
  reposnseData: CalendarModel[] = [];
  excelCalUpdateData: CalendarModel[] = [];

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';
  fileName: string = 'CalendarResults';

  public calendarModel = new CalendarModel(0, '', null, null, null, null, '', '', '', '', null, '', null, '', false, null, '', '','');

  public displayedColumns = ['Select', 'valid_from_dt', 'valid_to_dt', 'payroll_due_dt', 'pay_dt', 'unlock', 'off_cycle', 'issalesrepaccess', 'cal_run_id'];
  public dataSource = new MatTableDataSource<CalendarModel>();

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;

  supervisorNamesSet = new Set<string>();
  public showLoading: boolean;
  public calRunIdsDropdownData: CalendarModel[];

  columnsExcelData: any;
  dataForExcel = [];
  ordersTableExcelHeaderColumns: TableColumn[];

  isAccessDisabled: boolean = false;

  constructor(private globalService: GlobalService, private httpService: HttpClient, private router: Router, private calendarService: CalendarService,
    public ete: ExportExcelService, private notificationService: NotificationService, private authGaurdService: AuthGaurdService) { }

  ngOnInit(): void {
    //Get Permissions
    this.isAccessDisabled = this.globalService._permissionCheck('calendar');

    this.ctype = this.calendarService.selectedCalcModel.calendarType;
    console.log("calendar_type = " + this.ctype);
    this.getCalc();
    this.getCalRunIdsDropdown();
    this.initializeExcelHeaders();
  }

  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.calendarUpdate;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {
    console.log(this.excelCalUpdateData);
    for (let js of this.excelCalUpdateData) {
      delete js.id;
      delete js.calendarType;
      delete js.active_flag;
      delete js.created_dt;
      delete js.created_by;
      delete js.updated_dt;
      delete js.updated_by;
      delete js.editMode;
      delete js.commPeriod;
      delete js.comment;
      delete js.calendarType;
    }
    this.dataForExcel = [];
    let reportData = null;
    this.excelCalUpdateData.forEach((row: any) => {
      console.log("obj === " + Object.values(row));
      this.dataForExcel.push(Object.values(row));
    })
     reportData = {
      title: 'CalendarUpdate',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.ete.exportExcel(reportData);
  }

  public onAddPayrollData(calForm: NgForm): void {
    this.showLoading = true;
    const formData = this.calendarService.createForm(calForm.value, this.ctype);
    this.subscriptions.push(
      this.calendarService.addPayrollCalendar(formData).subscribe(
        (response: CustomHttpRespone) => {
          this.clickButton('closeAddButton');
          this.notificationService.sendNotification(NotificationType.SUCCESS, `Payroll calendar added successfully`);
          this.getCalc();
          calForm.reset();
          this.showLoading = false;
        },
        (errorResponse: HttpErrorResponse) => {
          console.log(errorResponse);
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
          this.showLoading = false;
        }
      )
    );
  }

  public getCalRunIdsDropdown(): void {
    this.refreshing = true;
    this.calendarService.getCalRunIdsDropdown().subscribe(
      (response: CalendarModel[]) => {
        this.calRunIdsDropdownData = response;
        this.calRunIdsDropdownData = this.calRunIdsDropdownData.sort((a, b) => (a.cal_run_id < b.cal_run_id) ? -1 : 1);
        this.refreshing = false;
      }, (errorResponse: HttpErrorResponse) => {
        this.refreshing = false;
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    )
  }

  private clickButton(buttonId: string): void {
    document.getElementById(buttonId).click();
  }

  public updateCalc() {
    if (this.selectedCalcIds.length === 0) {
      this.notificationService.sendNotification(NotificationType.WARNING, 'Select Records');
    } else {
      this.calendarService.updateCalcs(this.selectedCalcIds)
        .subscribe(response => {
          this.selectedCalcIds = [];
          console.log('response = ' + response);
          this.getCalc();
          // response = response as ErrorResponseMessage;
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        })
    }
  }


  public selectedCalIds(cal: CalendarModel, values: any) {
    console.log('calc values == ' + JSON.stringify(values));
    this.calendarModel = cal;
    console.log(this.calendarModel);
    this.calendarModel.updated_by = this.authGaurdService.loginUser();
    if (values.currentTarget.checked) {
      this.selectedCalcIds.push(this.calendarModel);
      cal.editMode = true;
    } else {
      //this.selectedCalcIds = [];
      this.selectedCalcIds.forEach((value: any, index: any) => {
        if (value.id == cal.id) this.selectedCalcIds.splice(index, 1);
      });
    }
    console.log('selectedCalcIds == ' + JSON.stringify(this.selectedCalcIds));
  }

  public getCalc(): void {
    this.refreshing = true;
    this.subscriptions.push(
      this.calendarService.getCalc(this.ctype).subscribe(
        (response: CalendarModel[]) => {
          this.reposnseData = response;
          console.log(this.reposnseData);
          this.dataSource.data = response as CalendarModel[];
          this.excelCalUpdateData = JSON.parse(JSON.stringify(response));
          this.refreshing = false;
        }, (errorResponse: HttpErrorResponse) => {
          this.refreshing = false;
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    );
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    saveAs(data, fileName + this.fileExtension);
  }

  public redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  public customSort = (event) => {
    console.log(event);
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }


}

